export const RESET_PIN_COOLDOWN_MS = 60_000;
export const RESET_PIN_COOLDOWN_KEY = 'step.resetPinCooldownUntil';

function getStorage() {
  if (typeof window === 'undefined') return null;
  return window.localStorage ?? null;
}

export function startResetPinCooldown(now = Date.now()) {
  const cooldownUntil = now + RESET_PIN_COOLDOWN_MS;
  getStorage()?.setItem(RESET_PIN_COOLDOWN_KEY, String(cooldownUntil));
  return cooldownUntil;
}

export function clearResetPinCooldown() {
  getStorage()?.removeItem(RESET_PIN_COOLDOWN_KEY);
}

export function getResetPinCooldownRemaining(now = Date.now()) {
  const stored = getStorage()?.getItem(RESET_PIN_COOLDOWN_KEY);
  const cooldownUntil = Number(stored);
  if (!Number.isFinite(cooldownUntil) || cooldownUntil <= 0) {
    clearResetPinCooldown();
    return 0;
  }

  const remaining = Math.max(0, cooldownUntil - now);
  if (remaining === 0) clearResetPinCooldown();
  return remaining;
}

export function formatResetPinCooldown(ms) {
  const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = String(totalSeconds % 60).padStart(2, '0');
  return `${minutes}:${seconds}`;
}
